<template>
  <div class="relative group flex" ref="buttonEl">
    <button class="rounded-md overflow-hidden shadow" @click="emit('apply')">
      <surface-editor-surface :surface="template" :export-scale="scale" mode="export" />
    </button>

    <u-tooltip v-if="canDelete" text="Delete Template" class="absolute top-1 right-1" :open-delay="500" :popper="{placement: 'top-end'}">
      <u-button
        variant="solid"
        color="red"
        size="2xs"
        class="opacity-0 group-hover:opacity-70 hover:!opacity-100 transition-all"
        icon="i-ri-close-line"
        @click.stop="emit('delete')"
      />
    </u-tooltip>

  </div>
</template>

<script setup>

  const emit = defineEmits(['apply', 'delete'])
  const props = defineProps({
    template: Object,
    canDelete: {
      type: Boolean,
      default: true
    }
  });

  const buttonEl = ref();
  const {width} = useElementSize(buttonEl);
  const scale = computed(() => width.value / props.template.width);

</script>
